import Approute from "./router/Index";
import { BrowserRouter } from "react-router-dom";
import WebSocketSessionHandler from "./components/WebSocketSessionHandler";

export default function App(){
  return(
   <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <WebSocketSessionHandler />
      <Approute/>
   </BrowserRouter>
  )
}